import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const AccountComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "AccountPage" */ "@circle-react/components/Modals/MemberProfileModal"
    ),
);

export const AccountPage = () => (
  <Suspense fallback={<PageLoader />}>
    <AccountComponent />
  </Suspense>
);
